import React, {useState} from "react";
import {useDownloadShipmentFile} from "../hooks/useDownloadShipmentFile";
import {OrdersShipmentDeliveryConfirmFileType, OrdersShipmentDeliveryConfirmType} from "../interface";
import {useForm, useWatch} from "react-hook-form";
import FileUploadWithText from "../../../../../components/common/fileUpload/fileUploadWithText/FileUploadWithText";
import {UploadedFile} from "../../../../customer/correspondent/detail/interface";
import useFileUpload from "../../../../../components/common/fileUpload/fileUploadWithText/hooks/useFileUpload";
import {useCreateDeliveryConfirmFile} from "../hooks/useUploadProductCurrencyExcelIn";
import {useUpdateShipmentDeliveryConfirm} from "../hooks/useUpdateShipmentDeliveryConfirm";
import {useModal} from "../../../../../hooks";
import {useDeleteShipmentFile} from "../hooks/useDeleteShipmentFile";
import AuthorityChecker from "../../../../../components/common/authorityGuard/AuthorityChecker";
import {useUser} from "../../../../../util/userContext/UserContext";

interface PropsType {
    ordersShipmentDeliveryConfirm: OrdersShipmentDeliveryConfirmType
    isDeadline: boolean | undefined
}

export default function Tab5({ordersShipmentDeliveryConfirm, isDeadline}: PropsType) {
    const {
        fileRef,
        files,
        handleButtonClick,
        handleChange,
        deleteFile,
        deleteUpdatedFile,
    } = useFileUpload({
        uploadedFiles: ordersShipmentDeliveryConfirm.deliveryConfirmFile
            ? [ordersShipmentDeliveryConfirm.deliveryConfirmFile as unknown as UploadedFile]
            : [],
        isMulti: false,
    });
    const {handleModal} = useModal();
    const {user} = useUser()

    const {mutate: mutateDownloadShipmentFile} = useDownloadShipmentFile()
    const {mutate: mutateCreateDeliveryConfirmFile} = useCreateDeliveryConfirmFile()
    const {mutate: mutateUpdateShipmentDeliveryConfirm} = useUpdateShipmentDeliveryConfirm()
    const {mutate: mutateDeleteShipmentFile} = useDeleteShipmentFile()

    const [file, setFile] = useState<(File & { fileId?: number }) | null>(null);

    const {register, handleSubmit, getValues, control, setValue, watch} = useForm({
        defaultValues: ordersShipmentDeliveryConfirm,
    });

    const watchData = {
        ...ordersShipmentDeliveryConfirm,
        ...useWatch<OrdersShipmentDeliveryConfirmType>({control}),
    } as OrdersShipmentDeliveryConfirmType

    const downloadShipmentRequest = (el: OrdersShipmentDeliveryConfirmFileType) => {
        mutateDownloadShipmentFile(el)
    }

    const handleFilesChange = (files: File[]) => {
        if (setFile) {
            if (files[0]) {
                setFile(files[0]);
            } else {
                setFile(null);
            }
        }
    };

    const btnUploadFile = () => {
        if (file) {
            if (file.fileId) {
                return;
            } else {
                const fd = new FormData();
                fd.append("newShipmentId", ordersShipmentDeliveryConfirm.newShipmentId);
                fd.append("file", file);

                mutateCreateDeliveryConfirmFile(fd);
            }
        } else {
            ordersShipmentDeliveryConfirm.deliveryConfirmFile
            && mutateDeleteShipmentFile(ordersShipmentDeliveryConfirm.deliveryConfirmFile)
        }
    };

    const btnSearchTransfer = () => {
        if (watchData?.invoiceNo?.length !== 13) {
            handleModal({
                isOpen: true,
                contents: "올바르지 않은 송장번호입니다.",
                type: "alert"
            })
        } else {
            window.open(`https://service.epost.go.kr/trace.RetrieveDomRigiTraceList.comm?sid1=${watchData.invoiceNo}&displayHeader=`, "_blank", "noopener,noreferrer")
        }
    }

    const btnSave = () => {
        mutateUpdateShipmentDeliveryConfirm(watchData)
    }

    return <div className="content_wrap">
        <h5 className="subheading mt-0">납품확인 정보</h5>
        <div className="table_scroll">
            <table className="table table-bordered my_table table_detail">
                <tbody>
                <tr>
                    <th>출하요청서</th>
                    <td colSpan={3}>
                        <a href={void 0} className="link-underline"
                           onClick={() => ordersShipmentDeliveryConfirm.shipmentRequestFile &&
                               downloadShipmentRequest(ordersShipmentDeliveryConfirm.shipmentRequestFile)}
                        >{ordersShipmentDeliveryConfirm.shipmentRequestFile?.fileOrgname}</a>
                    </td>
                </tr>
                <tr>
                    <th>거래명세서</th>
                    <td colSpan={3}>
                        <a href={void 0} className="link-underline"
                           onClick={() => ordersShipmentDeliveryConfirm.salesInvoiceFile &&
                               downloadShipmentRequest(ordersShipmentDeliveryConfirm.salesInvoiceFile)}
                        >{ordersShipmentDeliveryConfirm.salesInvoiceFile?.fileOrgname}</a>
                    </td>
                </tr>
                <tr>
                    <th>납품확인서</th>
                    <td colSpan={3} className="p-4px">
                        <div className="d-flex justify-content-between">
                            {/*<AuthorityChecker authorityNames={!isDeadline ? ['shipmentWriteYn'] : ['endWriteYn']}>*/}
                            <FileUploadWithText
                                mode={!isDeadline
                                    ? user?.authority.shipmentWriteYn === "Y" ? "RU" : "R"
                                    : user?.authority.endWriteYn === "Y" ? "RU" : "R"
                                }
                                fileRef={fileRef}
                                files={files}
                                onFilesChange={handleFilesChange}
                                uploadedFiles={
                                    ordersShipmentDeliveryConfirm.deliveryConfirmFile
                                        ? [ordersShipmentDeliveryConfirm.deliveryConfirmFile as unknown as UploadedFile]
                                        : []
                                }
                                downloadMutate={() =>
                                    ordersShipmentDeliveryConfirm.deliveryConfirmFile && downloadShipmentRequest(ordersShipmentDeliveryConfirm.deliveryConfirmFile)
                                }
                                handleChange={handleChange}
                                handleButtonClick={handleButtonClick}
                                deleteUpdatedFile={deleteUpdatedFile}
                                deleteFile={deleteFile}
                            />
                            <AuthorityChecker authorityNames={!isDeadline
                                ? ['shipmentWriteYn']
                                : ['endWriteYn']
                            }>
                                <button
                                    className="btn btn-primary btn_search w-90px"
                                    onClick={btnUploadFile}
                                >
                                    저장
                                </button>
                            </AuthorityChecker>
                        </div>
                    </td>
                </tr>
                <tr>
                    <th>송장번호</th>
                    <td colSpan={3} className="p-4px">
                        <div className="d-flex">
                            <input
                                type="text"
                                className="form-control"
                                value={watch("invoiceNo")}
                                {...register("invoiceNo", {maxLength: 13,})}
                                onInput={(e) => {
                                    const target = e.target as HTMLInputElement;
                                    target.value = target.value.replace(/[^0-9]/g, '').slice(0, 13); // 숫자만 허용 + 13자리 제한
                                }}
                            />
                            <button className="btn btn-info btn_search ms-5px w-90px"
                                    onClick={btnSearchTransfer}>
                                <img src={process.env.PUBLIC_URL + "/assets/images/icon_search.png"} alt=""/>
                                배송조회
                            </button>
                            <AuthorityChecker authorityNames={!isDeadline
                                ? ['shipmentWriteYn']
                                : ['endWriteYn']}>
                                <button className="btn btn-primary btn_search ms-5px"
                                        onClick={btnSave}>
                                    저장
                                </button>
                            </AuthorityChecker>
                        </div>
                    </td>
                </tr>
                <tr>
                    <th style={{width: "16.66%"}}>마감일자</th>
                    <td>{ordersShipmentDeliveryConfirm.endDt}</td>
                    <th style={{width: "16.66%"}}>마감번호</th>
                    <td>{ordersShipmentDeliveryConfirm.endNo}</td>
                </tr>
                </tbody>
            </table>
        </div>

        {isDeadline &&
            <>
                <h5 className="subheading mt-0">세금계산서 정보</h5>
                <div className="table_scroll mb-0">
                    <table className="table table-bordered my_table table_detail">
                        <tbody>
                        <tr>
                            <th style={{width: "16.66%"}}>세금계산서 발행일자</th>
                            <td style={{width: "33.34%"}}>{watchData.taxInfo?.issueDate ?? ""}</td>
                            <th style={{width: "16.66%"}}>세금계산서 번호</th>
                            {/*<td className="p-4px">
                                <input type="text"
                                       className="form-control"
                                       defaultValue={watchData?.taxInfo?.taxNo ?? ""}
                                       {...register("taxInfo.taxNo")}/>
                            </td>*/}
                            <td>{watchData?.taxInfo?.taxNo ?? ""}</td>
                        </tr>
                        <tr>
                            <th>비고</th>
                            {/*<td className="p-4px" colSpan={3}>
                                <input type="text"
                                       className="form-control"
                                       defaultValue={watchData?.taxInfo?.remark ?? ""}
                                       {...register("taxInfo.remark")}/>
                            </td>*/}
                            <td colSpan={3}>{watchData?.taxInfo?.remark ?? ""}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </>}
    </div>
}